import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export const ProblemSection = () => {
  const scrollToForm = () => {
    document.getElementById('booking-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-be-navy relative overflow-hidden" data-id="element-178">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-179">
        {/* Image side */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative aspect-[4/5] sm:aspect-[5/4] lg:aspect-auto lg:min-h-[600px] overflow-hidden" data-id="element-180">
          <img src="https://cdn.magicpatterns.com/uploads/oSEhfvPSrKEsPTBKw9xjiQ/iStock-2220867677.jpg" alt="Close-up of skin with redness and irritation" className="w-full h-full object-cover" data-id="element-181" />
          {/* Gradient fade into the navy on the right edge for desktop */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-be-navy/40 lg:to-be-navy" data-id="element-182" />
          <div className="absolute inset-0 bg-gradient-to-t from-be-navy/60 via-transparent to-transparent lg:bg-none" data-id="element-183" />
        </motion.div>

        {/* Copy side */}
        <div className="flex items-center px-6 sm:px-10 lg:px-16 py-16 lg:py-24" data-id="element-184">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-lg" data-id="element-185">
            <div className="h-px bg-be-pink w-14 mb-6" data-id="element-186" />
            <p className="text-be-pink text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase mb-5" data-id="element-187">
              Sound Familiar?
            </p>

            <h2 className="text-white font-black uppercase leading-[1] tracking-tight text-4xl sm:text-5xl md:text-6xl mb-3" data-id="element-188">
              Want to <br className="hidden sm:block" data-id="element-189" />
              improve your skin?
            </h2>
            <h3 className="font-serif italic text-be-pink-light text-4xl sm:text-5xl md:text-6xl mb-8 leading-none" data-id="element-190">
              Do a reset<span className="text-be-pink" data-id="element-191">.</span>
            </h3>

            <p className="text-white/85 text-base sm:text-lg leading-relaxed mb-5" data-id="element-192">
              Redness. Breakouts. Dull tone. Texture that won't quit. The
              cleanser-and-hope routine only takes you so far — and the wrong
              treatment can set you back further.
            </p>
            <p className="text-white/70 text-sm sm:text-base leading-relaxed mb-8" data-id="element-193">
              A complimentary skin consult at Be Clinical gives you a real plan
              from a licensed medical provider. We diagnose what's actually
              happening, then map the treatments that will move the needle —
              starting with{' '}
              <span className="text-be-pink font-semibold" data-id="element-194">
                $150 toward your first one.
              </span>
            </p>

            <button onClick={scrollToForm} className="group inline-flex items-center gap-3 text-white font-bold tracking-[0.2em] uppercase text-sm border-b-2 border-be-pink pb-2 hover:text-be-pink-light transition-colors" data-id="element-195">
              Start Your Reset
              <ArrowRight size={16} className="text-be-pink transition-transform group-hover:translate-x-1" data-id="element-196" />
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
};